(function () {
  if (window.BareCart) return;
  var DATA;
  try { DATA = JSON.parse(document.getElementById('bcd-data').textContent); } catch (e) { return; }
  var S = DATA.settings;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var $ = function (sel, el) { return (el || document).querySelector(sel); };
  var drawer = document.getElementById('bcd');
  if (drawer.parentNode !== document.body) document.body.appendChild(drawer);
  var panel = $('.bcd__panel', drawer), body = $('[data-bcd-body]', drawer);
  var nativeFetch = window.fetch.bind(window);
  var cart = null, busy = false, isOpen = false, lastFocus = null, prevCount = null, prevShipDone = null, giftShown = false;
  var PRODUCTS = DATA.products || {};
  var GIFT = DATA.gift, TRIGGERS = (DATA.triggers || []).filter(Boolean);
  var REDUCED = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- helpers ---------- */
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function money(cents, short) {
    var n = Math.round(cents) / 100, neg = n < 0; n = Math.abs(n);
    var parts = (short ? Math.round(n).toString() : n.toFixed(2)).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var amt = parts.join('.');
    var fmt = S.money_format || 'R {{amount}}';
    return (neg ? '-' : '') + fmt.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, amt);
  }
  function tpl(text, map) { return String(text || '').replace(/\{\{\s*(\w+)\s*\}\}/g, function (m, k) { return map[k] != null ? map[k] : m; }); }
  function api(url, body) {
    return nativeFetch(root + url, body ? { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) } : { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }
  function animateNum(el, to, short) {
    if (!el) return;
    var from = parseFloat(el.getAttribute('data-v') || 'NaN');
    el.setAttribute('data-v', to);
    if (REDUCED || isNaN(from) || from === to) { el.textContent = money(to, short); return; }
    var t0 = performance.now(), d = 650;
    (function step(t) { var k = Math.min(1, (t - t0) / d), e = 1 - Math.pow(1 - k, 3); el.textContent = money(from + (to - from) * e, short); if (k < 1) requestAnimationFrame(step); })(t0);
  }
  function variantInfo(item) {
    var p = PRODUCTS[item.handle];
    if (p) for (var i = 0; i < p.variants.length; i++) if (p.variants[i].id === item.variant_id) return { p: p, v: p.variants[i] };
    return null;
  }
  function loadMissing(items) {
    var need = items.filter(function (it) { return !PRODUCTS[it.handle]; }).map(function (it) { return it.handle; });
    need = need.filter(function (h, i) { return need.indexOf(h) === i; });
    return Promise.all(need.map(function (h) {
      return nativeFetch(root + 'products/' + h + '.js').then(function (r) { return r.json(); }).then(function (p) {
        PRODUCTS[h] = { id: p.id, options: (p.options || []).map(function (o) { return o.name || o; }), variants: p.variants.map(function (v) { return { id: v.id, title: v.title, price: v.price, compare: v.compare_at_price || v.price, available: v.available }; }) };
      }).catch(function () {});
    }));
  }
  function isGift(it) { return GIFT && it.variant_id === GIFT.variant_id; }
  function hasTrigger(c) { return c.items.some(function (it) { return TRIGGERS.indexOf(it.product_id) > -1; }); }
  function realCount(c) { return c.items.reduce(function (n, it) { return n + (isGift(it) ? 0 : it.quantity); }, 0); }

  /* ---------- timer ---------- */
  var TKEY = 'bcd_timer_end';
  function tGet() { try { return parseInt(localStorage.getItem(TKEY), 10) || 0; } catch (e) { return 0; } }
  function tSet(v) { try { v ? localStorage.setItem(TKEY, String(v)) : localStorage.removeItem(TKEY); } catch (e) {} }
  function tReset() { if (S.timer_show && S.timer_reset) tSet(Date.now() + (S.timer_minutes || 5) * 60000); }
  function tTick() {
    var el = $('[data-bcd-timer]', drawer);
    if (!S.timer_show || !cart || !cart.item_count) { el.hidden = true; return; }
    var end = tGet();
    if (!end) { end = Date.now() + (S.timer_minutes || 5) * 60000; tSet(end); }
    var left = end - Date.now();
    if (left <= 0) {
      if (S.timer_clear && !busy) { tSet(0); busy = true; api('cart/clear.js', {}).then(function (c) { busy = false; set(c); }).catch(function () { busy = false; }); return; }
      if (!S.timer_clear) { tSet(Date.now() + (S.timer_minutes || 5) * 60000); left = (S.timer_minutes || 5) * 60000; }
    }
    left = Math.max(0, left);
    var m = Math.floor(left / 60000), s = Math.floor(left % 60000 / 1000);
    var time = (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
    el.hidden = false;
    el.classList.toggle('is-low', left < 60000);
    el.innerHTML = tpl(esc(S.timer_text), { timer: '<b>' + time + '</b>' });
  }

  /* ---------- render ---------- */
  var ICON_TAG = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 12V4a1 1 0 011-1h8l9 9-9 9-9-9z" fill="currentColor"/><circle cx="7.5" cy="7.5" r="1.6" fill="#fff"/></svg>';
  var ICON_BIN = '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true"><path d="M4 7h16M10 11v6M14 11v6M6 7l1 13h10l1-13M9 7V4h6v3" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var ICON_GIFT = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="8" width="18" height="4" rx="1"/><path d="M12 8v13M19 12v8a1 1 0 01-1 1H6a1 1 0 01-1-1v-8"/><path d="M7.5 8a2.5 2.5 0 010-5C10 3 12 8 12 8s2-5 4.5-5a2.5 2.5 0 010 5"/></svg>';
  var TRUCK = '<svg viewBox="0 0 40 40" aria-hidden="true"><path d="M4 12h19v15H4z" fill="currentColor"/><path d="M23 17h7l5 5v5H23z" fill="currentColor" opacity=".85"/><path d="M26 19h3.5l3 3H26z" fill="#fff" opacity=".8"/><circle class="w" cx="11" cy="29" r="3.6" fill="#fff" stroke="currentColor" stroke-width="2.4"/><circle class="w" cx="29" cy="29" r="3.6" fill="#fff" stroke="currentColor" stroke-width="2.4"/><path d="M8 16h9M8 20h6" stroke="#fff" stroke-width="1.6" stroke-linecap="round" opacity=".6"/></svg>';

  function renderShip(c) {
    var host = $('[data-bcd-ship]', drawer);
    if (!S.ship_show || !c.item_count || !S.ship_threshold) { host.innerHTML = ''; prevShipDone = null; return; }
    var total = c.total_price, goal = S.ship_threshold, done = total >= goal;
    var pct = Math.max(4, Math.min(100, total / goal * 100));
    if (!host.firstChild) {
      host.innerHTML = '<div class="bcd__ship"><p class="bcd__ship-text"></p><div class="bcd__track"><div class="bcd__fill"></div><div class="bcd__truck">' + TRUCK + '</div><div class="bcd__goal"><svg class="lock" viewBox="0 0 24 24"><path d="M7 11V8a5 5 0 0110 0v3M6 11h12v9H6z" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linejoin="round"/></svg><svg class="ok" viewBox="0 0 24 24"><path d="M5 12.5l4.5 4.5L19 7.5" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg></div><div class="bcd__burst"></div></div></div>';
    }
    var wrap = host.firstChild, text = $('.bcd__ship-text', wrap), fill = $('.bcd__fill', wrap), truck = $('.bcd__truck', wrap);
    text.className = 'bcd__ship-text' + (done ? ' is-done' : '');
    text.innerHTML = done ? esc(S.ship_done) : tpl(esc(S.ship_text), { amount: '<b>' + money(goal - total, true) + '</b>' });
    var apply = function () {
      truck.classList.add('is-moving');
      clearTimeout(truck._t); truck._t = setTimeout(function () { truck.classList.remove('is-moving'); }, 950);
      fill.style.width = pct + '%'; truck.style.left = 'calc(' + pct + '% - ' + (pct > 92 ? 14 : 0) + 'px)';
    };
    if (!isOpen && !fill.style.width) { fill.style.width = '0%'; truck.style.left = '0%'; }
    requestAnimationFrame(function () { requestAnimationFrame(apply); });
    wrap.classList.toggle('is-done', done);
    if (done && prevShipDone === false) burst($('.bcd__burst', wrap));
    prevShipDone = done;
  }
  function burst(el) {
    if (!el || REDUCED) return;
    var cols = ['var(--bcd-accent)', 'var(--bcd-accent-2)', 'var(--bcd-save)', '#f4c56a', '#1f1f1f'];
    var html = '';
    for (var i = 0; i < 18; i++) { var a = Math.PI * 2 * i / 18, r = 40 + Math.random() * 34; html += '<i style="--c:' + cols[i % cols.length] + ';--x:' + Math.cos(a) * r + 'px;--y:' + (Math.sin(a) * r - 10) + 'px;--r:' + (Math.random() * 360) + 'deg"></i>'; }
    el.innerHTML = html; el.classList.remove('go'); void el.offsetWidth; el.classList.add('go');
    setTimeout(function () { el.innerHTML = ''; }, 1000);
  }

  function perkHTML(value) {
    return '<div class="bcd__perk">' + ICON_GIFT + '<span><b>' + esc(S.gift_badge) + ':</b> ' + esc(S.gift_title) + '</span>' +
      (value > 0 ? '<s>' + money(value, true) + '</s>' : '') + '<em>FREE</em></div>';
  }
  function lineHTML(it, i, perk) {
    var info = variantInfo(it);
    var compareEach = info ? Math.max(info.v.compare, it.original_price) : it.original_price;
    var was = compareEach * it.quantity, now = it.final_line_price, save = was - now;
    var opts = '';
    if (info && info.p.variants.length > 1) {
      var label = (info.p.options && info.p.options[0]) || 'Option';
      opts = '<select class="bcd__select" data-key="' + esc(it.key) + '" aria-label="' + esc(label) + '">' +
        info.p.variants.map(function (v) { return '<option value="' + v.id + '"' + (v.id === it.variant_id ? ' selected' : '') + (v.available ? '' : ' disabled') + '>' + esc(v.title) + '</option>'; }).join('') + '</select>';
    } else if (it.variant_title && it.variant_title !== 'Default Title') {
      opts = '<span class="bcd__opt-fixed">' + esc(it.variant_title) + '</span>';
    }
    var img = it.image ? it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=180' : '';
    return '<div class="bcd__item enter" style="--i:' + i + '" data-key="' + esc(it.key) + '">' +
      '<a class="bcd__img" href="' + esc(it.url) + '">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy" width="72" height="72">' : '') + '</a>' +
      '<div class="bcd__info"><a class="bcd__name" href="' + esc(it.url) + '">' + esc(it.product_title.replace(/^Bare\s*&(amp;)?\s*Co\.?\s*/i, '')) + '</a>' +
      '<div class="bcd__ctl">' + opts + '<div class="bcd__qty"><button type="button" data-qty="-1" aria-label="Decrease quantity">−</button><span>' + it.quantity + '</span><button type="button" data-qty="1" aria-label="Increase quantity">+</button></div>' +
      '<button type="button" class="bcd__del" data-del aria-label="Remove ' + esc(it.product_title) + '">' + ICON_BIN + '</button></div></div>' +
      '<div class="bcd__right">' + (save > 0 ? '<span class="bcd__was">' + money(was) + '</span>' : '') + '<span class="bcd__now" data-now="' + now + '">' + money(now) + '</span>' +
      (save > 0 ? '<span class="bcd__save">' + ICON_TAG + esc(tpl(S.save_text, { amount: money(save, true) })) + '</span>' : '') + '</div>' +
      (perk != null ? perkHTML(perk) : '') + '</div>';
  }
  function giftHTML(compare, i) {
    return '<div class="bcd__gift enter' + (giftShown ? '' : ' pop') + '" style="--i:' + i + '"><div class="bcd__gift-ico">' + ICON_GIFT + '</div>' +
      '<div><span class="bcd__gift-badge">' + esc(S.gift_badge) + '</span><span class="bcd__gift-name">' + esc(S.gift_title) + '</span><span class="bcd__gift-sub">' + esc(S.gift_sub) + '</span></div>' +
      '<div class="bcd__right">' + (compare > 0 ? '<span class="bcd__was">' + money(compare) + '</span>' : '') + '<span class="bcd__free">FREE</span>' +
      (compare > 0 ? '<span class="bcd__save">' + ICON_TAG + esc(tpl(S.save_text, { amount: money(compare, true) })) + '</span>' : '') + '</div></div>';
  }
  function giftValue() { return GIFT ? (GIFT.compare || S.gift_value) : S.gift_value; }

  function totals(c) {
    var was = 0;
    c.items.forEach(function (it) {
      var info = variantInfo(it);
      var ce = isGift(it) ? (GIFT.compare || S.gift_value) : (info ? Math.max(info.v.compare, it.original_price) : it.original_price);
      was += ce * it.quantity;
    });
    /* Display-only gift when no gift product is set up */
    var gift = 0;
    if (S.gift_show && !GIFT && hasTrigger(c)) { was += S.gift_value; gift = S.gift_value; }
    else if (GIFT && S.gift_show) c.items.forEach(function (it) { if (isGift(it)) gift += (GIFT.compare || S.gift_value) * it.quantity; });
    return { was: was, now: c.total_price, save: Math.max(0, was - c.total_price), gift: gift };
  }

  function render(c, fresh) {
    var count = realCount(c);
    var title = $('[data-bcd-title]', drawer);
    title.innerHTML = tpl(esc(S.title), { count: '<span class="bcd__count">' + count + '</span>', item_count: '<span class="bcd__count">' + count + '</span>' });
    if (prevCount != null && count !== prevCount) { var ce = $('.bcd__count', title); if (ce) { ce.classList.add('bump'); } }
    updateBadges(count, prevCount != null && count > prevCount);
    prevCount = count;

    var empty = $('[data-bcd-empty]', drawer), foot = $('[data-bcd-foot]', drawer), list = $('[data-bcd-items]', drawer);
    if (!c.item_count) {
      list.innerHTML = ''; $('[data-bcd-ups]', drawer).innerHTML = ''; renderShip(c);
      empty.hidden = false; foot.hidden = true;
      empty.innerHTML = '<div class="bcd__empty"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><path d="M6 7h12l-1 13H7z"/><path d="M9 7a3 3 0 016 0"/></svg><p>' + esc(S.empty_title) + '</p>' + (S.empty_button ? '<button type="button" data-bcd-close>' + esc(S.empty_button) + '</button>' : '') + '</div>';
      giftShown = false; tTick(); return;
    }
    empty.hidden = true; foot.hidden = false;
    renderShip(c);

    var html = '', idx = 0;
    var showPerk = S.gift_show && (GIFT ? c.items.some(isGift) : hasTrigger(c));
    var perkVal = GIFT ? (GIFT.compare || S.gift_value) : S.gift_value;
    c.items.forEach(function (it) { if (!isGift(it)) html += lineHTML(it, idx++, null); });
    giftShown = showPerk;
    /* Free gift: one quiet line above the totals */
    var gr = $('.bcd__giftrow', foot);
    if (!gr) { gr = document.createElement('div'); gr.className = 'bcd__giftrow'; foot.insertBefore(gr, foot.firstChild); }
    gr.hidden = !showPerk;
    if (showPerk) gr.innerHTML = '<i aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M6 12.5l4 4L18 8.5" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"/></svg></i><span>' + esc(S.gift_title) + '</span>' +
      (perkVal > 0 ? '<s>' + money(perkVal, true) + '</s>' : '') + '<em>FREE</em>';
    list.innerHTML = html;
    if (!fresh) list.querySelectorAll('.enter').forEach(function (e) { e.classList.remove('enter'); });

    renderUps(c);

    var t = totals(c);
    var disc = $('[data-bcd-disc]', drawer);
    disc.hidden = !(t.save > 0);
    $('[data-bcd-disc-label]', drawer).textContent = S.discount_label;
    var da = $('[data-bcd-disc-amt]', drawer);
    if (t.save > 0) { var from = parseFloat(da.getAttribute('data-v') || 'NaN'); da.setAttribute('data-v', t.save); animateMinus(da, isNaN(from) ? null : from, t.save); }
    /* Show how the discount is made up: product savings + the free guide */
    var bd = $('.bcd__disc-why', foot);
    if (!bd) { bd = document.createElement('div'); bd.className = 'bcd__disc-why'; disc.parentNode.insertBefore(bd, disc.nextSibling); }
    bd.hidden = !(t.save > 0 && t.gift > 0);
    if (!bd.hidden) bd.innerHTML = '<span>' + esc(money(t.save - t.gift, true)) + ' off products</span><span>+</span><span>' + esc(money(t.gift, true)) + ' free digital guide</span>';
    $('[data-bcd-sub-label]', drawer).textContent = S.subtotal_label;
    $('[data-bcd-sub-was]', drawer).textContent = t.was > t.now ? money(t.was) : '';
    animateNum($('[data-bcd-sub-now]', drawer), t.now);
    $('[data-bcd-go-text]', drawer).textContent = tpl(S.checkout_text, { cart_total: money(t.now), total: money(t.now) });
    tTick();
  }
  function animateMinus(el, from, to) {
    if (REDUCED || from == null || from === to) { el.textContent = '-' + money(to); return; }
    var t0 = performance.now();
    (function step(t) { var k = Math.min(1, (t - t0) / 650), e = 1 - Math.pow(1 - k, 3); el.textContent = '-' + money(from + (to - from) * e); if (k < 1) requestAnimationFrame(step); })(t0);
  }
  function renderUps(c) {
    var host = $('[data-bcd-ups]', drawer);
    if (!S.upsell_show) { host.innerHTML = ''; return; }
    var inCart = c.items.map(function (it) { return it.product_id; });
    var list = (DATA.upsells || []).filter(function (u) { return u.available && inCart.indexOf(u.product_id) === -1; });
    if (!list.length) { host.innerHTML = ''; return; }
    host.innerHTML = '<div class="bcd__ups">' + (S.upsell_heading ? '<p class="bcd__ups-h">' + esc(S.upsell_heading) + '</p>' : '') + list.map(function (u) {
      var pct = u.compare > u.price ? Math.round((u.compare - u.price) / u.compare * 100) : 0;
      return '<div class="bcd__up" data-up="' + u.variant_id + '"><a class="bcd__up-img" href="' + esc(u.url) + '"><img src="' + esc(u.img) + '" alt="" loading="lazy" width="52" height="52"></a><div class="bcd__up-info">' +
        '<p class="bcd__up-t">' + esc(u.title.replace(/^Bare\s*&\s*Co\.?\s*/i, '')) + '</p><div class="bcd__up-p"><b>' + money(u.price, true) + '</b>' + (pct ? '<s>' + money(u.compare, true) + '</s><span class="bcd__up-pct">' + esc(tpl(S.save_text, { amount: pct + '%' })) + '</span>' : '') + '</div></div>' +
        '<button type="button" class="bcd__up-btn" data-up-add="' + u.variant_id + '"><span>' + esc(S.upsell_button) + '</span></button></div>';
    }).join('') + '</div>';
  }

  /* ---------- badges ---------- */
  function updateBadges(count, bump) {
    var icon = document.getElementById('cart-icon-bubble');
    if (icon) {
      var dot = icon.querySelector('.bcd-dot');
      if (!dot) { dot = document.createElement('span'); dot.className = 'bcd-dot'; dot.setAttribute('aria-hidden', 'true'); icon.appendChild(dot); }
      dot.textContent = count; dot.style.display = count ? '' : 'none';
      if (bump) { dot.classList.remove('bump'); void dot.offsetWidth; dot.classList.add('bump'); }
    }
    var sc = document.querySelector('[data-bcs-count]');
    if (sc) { sc.textContent = count || ''; if (bump) { sc.classList.remove('bump'); void sc.offsetWidth; sc.classList.add('bump'); } }
  }

  /* ---------- cart state ---------- */
  function set(c, fresh) {
    cart = c;
    loadMissing(c.items).then(function () {
      if (ensureGift(c)) return;
      render(c, fresh);
    });
  }
  function refresh(fresh) { return api('cart.js').then(function (c) { set(c, fresh); return c; }); }
  var giftBusy = false;
  function ensureGift(c) {
    if (!GIFT || !S.gift_show || giftBusy) return false;
    var trig = hasTrigger(c), lines = c.items.filter(isGift), qty = lines.reduce(function (n, l) { return n + l.quantity; }, 0);
    var job = null;
    if (trig && qty === 0) job = api('cart/add.js', { items: [{ id: GIFT.variant_id, quantity: 1, properties: { _bare_gift: '1' } }] });
    else if (trig && qty > 1) job = api('cart/change.js', { id: lines[0].key, quantity: 1 });
    else if (!trig && qty > 0) job = api('cart/change.js', { id: lines[0].key, quantity: 0 });
    if (!job) return false;
    giftBusy = true;
    job.catch(function () {}).then(function () { return api('cart.js'); }).then(function (nc) { giftBusy = false; cart = nc; render(nc, false); }).catch(function () { giftBusy = false; render(c, false); });
    return true;
  }
  function mutate(url, payload, el) {
    if (el) el.classList.add('is-busy');
    tReset();
    return api(url, payload).then(function () { return refresh(false); }).catch(function (e) {
      if (el) el.classList.remove('is-busy');
      alert((e && (e.description || e.message)) || 'Sorry, something went wrong.');
    });
  }

  /* ---------- open / close ---------- */
  function open() {
    if (isOpen) return;
    isOpen = true; lastFocus = document.activeElement;
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('bcd-lock');
    drawer.classList.add('is-open');
    refresh(true);
    setTimeout(function () { try { panel.focus({ preventScroll: true }); } catch (e) {} }, 60);
  }
  function close() {
    if (!isOpen) return;
    isOpen = false;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('bcd-lock');
    if (lastFocus && lastFocus.focus) try { lastFocus.focus({ preventScroll: true }); } catch (e) {}
  }

  drawer.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-bcd-close]')) { e.preventDefault(); close(); return; }
    var q = t.closest('[data-qty]');
    if (q) { var row = q.closest('[data-key]'), it = cart.items.filter(function (x) { return x.key === row.dataset.key; })[0]; if (it) mutate('cart/change.js', { id: it.key, quantity: Math.max(0, it.quantity + (+q.dataset.qty)) }, row); return; }
    var d = t.closest('[data-del]');
    if (d) { var r = d.closest('[data-key]'); r.classList.add('is-leaving'); mutate('cart/change.js', { id: r.dataset.key, quantity: 0 }, r); return; }
    var u = t.closest('[data-up-add]');
    if (u) {
      u.classList.add('is-busy'); tReset();
      api('cart/add.js', { items: [{ id: +u.dataset.upAdd, quantity: 1 }] }).then(function () {
        u.classList.remove('is-busy'); u.classList.add('is-done'); u.querySelector('span').textContent = '✓';
        var card = u.closest('.bcd__up'); setTimeout(function () { if (card) card.classList.add('is-gone'); }, 450);
        setTimeout(function () { refresh(true); }, 800);
      }).catch(function (err) { u.classList.remove('is-busy'); alert((err && err.description) || 'Could not add this item.'); });
      return;
    }
    var go = t.closest('[data-bcd-go]');
    if (go) go.classList.add('is-busy');
  });
  drawer.addEventListener('change', function (e) {
    var sel = e.target.closest('.bcd__select'); if (!sel) return;
    var it = cart.items.filter(function (x) { return x.key === sel.dataset.key; })[0]; if (!it) return;
    var row = sel.closest('[data-key]'); row.classList.add('is-busy'); tReset();
    /* Add the new colour with the same quantity and bundle details, then remove the old line */
    /* Bundle apps can remove the rest of a bundle when its main line goes, so put back anything that disappears */
    var before = cart.items.filter(function (x) { return x.key !== it.key; }).map(function (x) { return { id: x.variant_id, q: x.quantity, p: x.properties || {} }; });
    api('cart/add.js', { items: [{ id: +sel.value, quantity: it.quantity, properties: it.properties || {} }] })
      .then(function () { return api('cart/change.js', { id: it.key, quantity: 0 }); })
      .then(function () { return api('cart.js'); })
      .then(function (nc) {
        var have = {}; nc.items.forEach(function (x) { var k = x.variant_id + JSON.stringify(x.properties || {}); have[k] = (have[k] || 0) + x.quantity; });
        var back = [];
        before.forEach(function (b) {
          if (b.id === +sel.value && JSON.stringify(b.p) === JSON.stringify(it.properties || {})) return;
          var k = b.id + JSON.stringify(b.p), missing = b.q - (have[k] || 0);
          if (missing > 0) { back.push({ id: b.id, quantity: missing, properties: b.p }); have[k] = b.q; }
        });
        return back.length ? api('cart/add.js', { items: back }) : null;
      })
      .then(function () { return refresh(false); })
      .catch(function (err) { row.classList.remove('is-busy'); alert((err && err.description) || 'That colour is not available right now.'); refresh(false); });
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && isOpen) close(); });

  /* Cart icons open this cart */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('#cart-icon-bubble, a[href$="/cart"]:not(.bcd a), [data-bcs-cart]');
    if (!a || a.closest('.bcd')) return;
    if (location.pathname.replace(/\/$/, '').slice(-5) === '/cart') return;
    e.preventDefault(); e.stopImmediatePropagation(); open();
  }, true);

  /* The theme's own drawer and other apps (e.g. Bundlex) hand over to this cart */
  if (window.customElements) customElements.whenDefined('cart-drawer').then(function () {
    var C = customElements.get('cart-drawer'); if (!C) return;
    C.prototype.open = function () { open(); };
    C.prototype.close = function () { close(); };
    C.prototype.renderContents = function () { tReset(); if (isOpen) refresh(true); else open(); };
  });

  /* Watch cart changes made anywhere on the page */
  var CART_RE = /\/cart\/(add|change|update|clear)(\.js|\.json)?(\?|$)/;
  function onExternal(url, ok) {
    if (!ok) return;
    tReset();
    var isAdd = /\/cart\/add/.test(url);
    setTimeout(function () { if (isAdd) { if (isOpen) refresh(true); else open(); } else refresh(false); }, 60);
  }
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = nativeFetch(input, init);
    if (CART_RE.test(url)) p.then(function (r) { onExternal(url, r.ok); }).catch(function () {});
    return p;
  };
  var xo = XMLHttpRequest.prototype.open, xs = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (m, u) { this._bcdUrl = u; return xo.apply(this, arguments); };
  XMLHttpRequest.prototype.send = function () {
    var x = this;
    if (CART_RE.test(x._bcdUrl || '')) x.addEventListener('load', function () { onExternal(x._bcdUrl, x.status >= 200 && x.status < 300); });
    return xs.apply(this, arguments);
  };

  (function () {
    var st = document.createElement('style');
    st.textContent = '#bcd .bcd__giftrow{font-size:12px;gap:8px;margin:0 0 6px;padding:0 0 7px}#bcd .bcd__giftrow i{width:17px;height:17px}#bcd .bcd__giftrow i svg{width:10px;height:10px}#bcd .bcd__giftrow s{font-size:11.5px}#bcd .bcd__giftrow em{font-size:12px}' +
      '#bcd .bcd__disc-why{display:flex;justify-content:flex-end;gap:5px;margin:-1px 0 5px;font-size:11px;color:#8a837e;line-height:1.3}#bcd .bcd__disc-why[hidden]{display:none}';
    document.head.appendChild(st);
  })();

  window.BareCart = { open: open, close: close, refresh: refresh };
  refresh(false);
  setInterval(function () { if (cart && cart.item_count) tTick(); }, 1000);

  /* ---------- Sticky add to cart (product pages) ---------- */
  var bar = document.getElementById('bcs');
  if (bar) {
    if (bar.parentNode !== document.body) document.body.appendChild(bar);
    var mainBtn = function () { return document.querySelector('product-form button[name=add], .product-form__submit'); };
    var parse = function (t) { var n = parseFloat(String(t || '').replace(/[^\d.,]/g, '').replace(/,/g, '')); return isNaN(n) ? null : Math.round(n * 100); };
    var fill = function () {
      var off = document.querySelector('.js-bx-offer.bx-active');
      var title, price, was, img;
      if (off) {
        var pr = off.querySelector('.js-bx-offer-price');
        title = (off.querySelector('.bx-offer-title') || {}).textContent;
        price = pr ? parse((pr.querySelector('.bx-discounted-price') || {}).textContent) : null;
        was = pr ? parse((pr.querySelector('.bx-original-price') || {}).textContent) : null;
        var oi = off.querySelector('.bx-offer-image'); if (oi) img = oi.currentSrc || oi.src;
      }
      if (price == null) {
        var h = (location.pathname.match(/\/products\/([^/?#]+)/) || [])[1], p = PRODUCTS[h];
        var idEl = document.querySelector('product-form [name=id]'), vid = idEl ? +idEl.value : 0;
        var v = p && (p.variants.filter(function (x) { return x.id === vid; })[0] || p.variants[0]);
        if (v) { price = v.price; was = v.compare; }
      }
      if (title) bar.querySelector('[data-bcs-title]').textContent = title.trim();
      if (img) bar.querySelector('[data-bcs-img]').src = img;
      if (price != null) {
        bar.querySelector('[data-bcs-price]').textContent = money(price);
        bar.querySelector('[data-bcs-was]').textContent = was > price ? money(was) : '';
        bar.querySelector('[data-bcs-save]').textContent = was > price ? tpl(S.save_text, { amount: money(was - price, true) }) : '';
      }
    };
    fill();
    var w = document.querySelector('.bx-widget') || document.querySelector('product-form');
    if (w && window.MutationObserver) new MutationObserver(function () { clearTimeout(fill._t); fill._t = setTimeout(fill, 80); }).observe(w.parentNode || w, { subtree: true, childList: true, attributes: true, attributeFilter: ['class', 'aria-checked'] });
    document.addEventListener('change', function () { setTimeout(fill, 60); });

    bar.querySelector('[data-bcs-add]').addEventListener('click', function () {
      var b = mainBtn(), me = this;
      if (!b) { open(); return; }
      me.classList.add('is-busy'); setTimeout(function () { me.classList.remove('is-busy'); }, 1800);
      b.click();
    });

    /* Always show an add-to-cart button: the sticky bar shows whenever the main button is off screen */
    var target = null;
    var watch = function () {
      var b = mainBtn();
      if (!b || b === target) return;
      target = b;
      /* Only once the main button has scrolled up past the top of the screen */
      new IntersectionObserver(function (entries) {
        var e = entries[0], on = !e.isIntersecting && e.boundingClientRect.bottom < 0;
        bar.classList.toggle('is-on', on);
        bar.setAttribute('aria-hidden', on ? 'false' : 'true');
        document.body.classList.toggle('bcs-pad', on);
      }, { threshold: 0 }).observe(b);
    };
    watch(); setTimeout(watch, 1500);
  }
})();
